import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoginAlternativeAuthenticationService } from '../../services/login/data-services/login-alternative-authentication/login-alternative-authentication.service';
import { LoginPostWithContinueService } from '../../services/login/data-services/login-post-with-continue/login-post-with-continue-service';
import { LoginPostWithRememberUserService } from '../../services/login/data-services/login-post-with-remember-user/login-post-with-remember-user-service';
import { LoginUserIdentifierService } from '../../services/login/data-services/login-user-identifier/login-user-identifier.service';
import { SwapAccessTokenService } from '../../services/login/data-services/swap-access-token/swap-access-token-service';
import { CancelAuthenticationService } from '../../services/multi-factor-authentication/data-services/cancel-authentication/cancel-authentication.service';
import { ContinueAuthenticationService } from '../../services/multi-factor-authentication/data-services/continue-authentication/continue-authentication.service';
import { FlyDeltaPollService } from '../../services/multi-factor-authentication/data-services/fly-delta-poll/fly-delta-poll.service';
import { InitiateAuthenticationService } from '../../services/multi-factor-authentication/data-services/initiate-authentication/initiate-authentication.service';
import { LoginRememberMeErrorUtilService } from '../../utils/login/login-remember-me-error-util.service';

@Injectable({
  providedIn: 'root'
})
export class LoginSubmitAuthenticationIdentifierHelperExtendedService {
  stopPoll$ = new Subject();
  flowId = '';
  encyToken = '';
  uid = '';

  loginUserIdentifier = inject(LoginUserIdentifierService);
  initiateAuthentication = inject(InitiateAuthenticationService);
  flyDeltaPoll = inject(FlyDeltaPollService);
  continueAuthentication = inject(ContinueAuthenticationService);
  cancelAuthentication = inject(CancelAuthenticationService);
  loginRememberMeErrorUtil = inject(LoginRememberMeErrorUtilService);
  loginPostWithRememberUser = inject(LoginPostWithRememberUserService);
  loginPostWithContinue = inject(LoginPostWithContinueService);
  swapAccessToken = inject(SwapAccessTokenService);
  loginAlternativeAuthentication = inject(
    LoginAlternativeAuthenticationService
  );
}
